import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=2899cba7&"
import script from "./Brand.vue?vue&type=script&lang=js&"
export * from "./Brand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports